module.exports = __webpack_public_path__ + "static/media/homebg.10ba5321.png";